import React from 'react'

import InfoModal from 'Components/InfoModal'

const RecommendationSourcesInfo = (): JSX.Element => (
  <InfoModal>
    <h2>Quellen zu den Empfehlungen von eBalance</h2>
    <p>
      Die Grundlage der Empfehlungen von eBalance bilden die Publikationen von Ernährungsfachgesellschaften sowie die
      der Weltgesundheitsorganisation (WHO).
    </p>

    <p>
      eBalance ist keine medizinische App und kann somit nicht für die Diagnose, Beratung, Vorbeugung und Behandlung von
      Krankheiten eingesetzt werden. Wenden Sie sich stets an einen Arzt, wenn Sie eine Beratung oder eine Behandlung
      benötigen.
    </p>

    <p>
      Unsere Angaben zur Energiezufuhr basieren auf der Formel zur Berechnung des Ruheenergieverbrauchs nach Müller et
      al. 2004.
      <br />
      <a href="https://pubmed.ncbi.nlm.nih.gov/15531690/" target="_blank" rel="noopener noreferrer">
        https://pubmed.ncbi.nlm.nih.gov/15531690/
      </a>
    </p>

    <p>
      Unseren Hinweisen zur Nährstoffzufuhr liegen die D-A-CH-Referenzwerte zugrunde, die von den Fachgesellschaften aus
      Deutschland (D), Österreich (A) und der Schweiz (CH) gemeinsam entwickelt wurden.
      <br />
      <a href="https://www.dge.de/wissenschaft/referenzwerte/" target="_blank" rel="noopener noreferrer">
        https://www.dge.de/wissenschaft/referenzwerte/
      </a>
    </p>

    <p>
      Bei der Einordnung des BMI und den daraus abgeleiteten Empfehlungen richten wir uns nach der Klassifikation der
      WHO.
      <br />
      <a
        href="https://www.who.int/europe/news-room/fact-sheets/item/a-healthy-lifestyle---who-recommendations"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.who.int/europe/news-room/fact-sheets/item/a-healthy-lifestyle---who-recommendations
      </a>
    </p>

    <p>
      Für unsere Angaben zum Thema Bauchumfang orientieren wir uns an den Leitlinien zur Prävention und Therapie von
      Adipositas der Deutschen Adipositas-Gesellschaft.
      <br />
      <a href="https://register.awmf.org/de/leitlinien/detail/050-001" target="_blank" rel="noopener noreferrer">
        https://register.awmf.org/de/leitlinien/detail/050-001
      </a>
    </p>

    <p>
      Weitere Hinweise zu einer ausgewogenen Ernährung (Menügestaltung, Portionsgrössen, Lebensmittelauswahl) folgen den
      Empfehlungen der Schweizerischen Gesellschaft für Ernährung. Diese berücksichtigen wir auch bei der Erstellung der
      täglichen Menüpläne.
      <br />
      <a
        href="https://www.sge-ssn.ch/media/ct_protected_attachments/1f2b94d775a3fc5ca3ecd581b133b4/Schweizer-Ernaehrungsempfehlungen_Langversion_DE.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.sge-ssn.ch/media/ct_protected_attachments/1f2b94d775a3fc5ca3ecd581b133b4/Schweizer-Ernaehrungsempfehlungen_Langversion_DE.pdf
      </a>
    </p>
  </InfoModal>
)

export default RecommendationSourcesInfo
